import 'vite/modulepreload-polyfill';

// Open-close details-utils
import '@zachleat/details-utils';

class App {
  constructor() {
    this.init();
  }

  init() {
    this.modalDefault();
    this.responsiveFluidIframe();
  }

  modalDefault() {
    const bodyElement = document.querySelector('body');
    const modalOpeners = document.querySelectorAll('.modal-opener');

    modalOpeners.forEach((opener) => {
      opener.addEventListener('click', (event) => {
        event.preventDefault();

        const modalId = opener.dataset.id || opener.getAttribute('href')?.replace('#', '');

        if (!modalId) return;

        const modal = document.getElementById(modalId);

        if (!modal) return;

        bodyElement.classList.add('overflow-hidden');
        modal.showModal();
        modal.removeAttribute('inert');
      });
    });

    document.querySelectorAll('.modal-closer').forEach((closer) => {
      closer.addEventListener('click', (event) => {
        event.preventDefault();

        const modal = closer.closest('dialog');

        if (!modal) return;

        bodyElement.classList.remove('overflow-hidden');
        modal.close();
        modal.setAttribute('inert', '');
      });
    });

    document.querySelectorAll('dialog.modal').forEach((modal) => {
      modal.addEventListener('click', (e) => {
        const dialogDimensions = modal.getBoundingClientRect();

        if (
          e.clientX < dialogDimensions.left ||
          e.clientX > dialogDimensions.right ||
          e.clientY < dialogDimensions.top ||
          e.clientY > dialogDimensions.bottom
        ) {
          bodyElement.classList.remove('overflow-hidden');
          modal.close();
          modal.setAttribute('inert', '');
        }
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const openModal = document.querySelector('dialog[open].modal');

        if (openModal) {
          bodyElement.classList.remove('overflow-hidden');
          openModal.close();
          openModal.setAttribute('inert', '');
        }
      }
    });
  }

  responsiveFluidIframe() {
    document.querySelectorAll('.prose iframe').forEach((iframe) => {
      const fluidHtml = document.createElement('div');

      fluidHtml.classList.add('fluid-iframe', 'relative', 'h-auto', 'aspect-video');
      iframe.parentNode.appendChild(fluidHtml);
      fluidHtml.appendChild(iframe);
    });
  }
}

new App();
